// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
DO NOT REDISTRIBUTE
UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL */

.mapboxgl-map.cmd-key-active-kml .mapboxgl-canvas-container.mapboxgl-interactive {
  cursor: crosshair;
}
`, "",{"version":3,"sources":["webpack://./src/features/map/MapDraw/kmlBoxSelection.css"],"names":[],"mappings":"AAAA;;;8BAG8B;;AAE9B;EACE,iBAAiB;AACnB","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
